<template>
  <input
    type="text"
    inputmode="decimal"
    class="core-form-input"
    :value="draft"
    :aria-invalid="invalid"
    :class="{ 'core-form-error': invalid }"
    placeholder="-"
    @input="onInput"
    @blur="commit"
    @keydown.enter="($event.target as HTMLInputElement).blur()"
    @keydown.esc="reset" />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

// Allowed range of the complexity factor override; must match core-types and the widget validator
const MIN_FACTOR = 0.1
const MAX_FACTOR = 2
const props = defineProps<{ modelValue?: number | null }>()
const emit = defineEmits<{ 'update:modelValue': [value: number | null] }>()
const display = () => props.modelValue?.toFixed(2) ?? ''
const draft = ref(display())
const dirty = ref(false)
const invalid = ref(false)
watch(
  () => props.modelValue,
  () => {
    reset()
  }
)
function onInput(event: Event) {
  dirty.value = true
  draft.value = (event.target as HTMLInputElement).value
}
function reset() {
  dirty.value = false
  invalid.value = false
  draft.value = display()
}
function commit() {
  if (!dirty.value) return
  const value = draft.value.trim() ? Number(draft.value.replace(',', '.')) : null
  invalid.value = value !== null && !(value >= MIN_FACTOR && value <= MAX_FACTOR)
  if (invalid.value) return
  dirty.value = false
  emit('update:modelValue', value)
  draft.value = value?.toFixed(2) ?? ''
}
</script>
